
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Profile } from 'client-website-ts-library/types/Profile';

import ProfileCard from './ProfileCard.vue';
import Cards from './Layout/Cards.vue';

@Component({
  components: {
    ProfileCard,
  },
})
export default class ProfileCards extends Vue {
  @Prop({ default: [] })
  private readonly profiles!: Profile[];
}
